import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FlexBox, getSelectionListContext, Icon, } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback, useContext, useState } from 'react';
import styles from './favoriteItemLayout.module.scss';
import { getFavoriteItemLayoutContext, } from './favoriteItemLayoutContext';
/** Represents the layout of an item that can be favorited. */
export const FavoriteItemLayout = ({ item, isFavorite, isDisabled: disabled, children, }) => {
    const [favoriteToggle, setFavoriteToggle] = useState();
    const [isFavoriteDisabled, setIsFavoriteDisabled] = useState(false);
    const context = useContext(getSelectionListContext());
    const FavoriteItemLayoutContext = getFavoriteItemLayoutContext();
    const isDisabled = disabled || context.list.isDisabled;
    /** Handles toggling the favorite status. */
    const handleFavoriteToggle = useCallback((event) => {
        if (favoriteToggle) {
            favoriteToggle();
            event.stopPropagation();
        }
    }, [favoriteToggle]);
    return (_jsx(FavoriteItemLayoutContext.Provider, Object.assign({ value: { item, isFavorite, setFavoriteToggle, setIsFavoriteDisabled } }, { children: _jsxs(FlexBox, Object.assign({ justifyContent: "space-between", gap: "200" }, { children: [_jsx(Box, Object.assign({ className: classnames(styles.contentContainer, {
                        [styles.isDisabled]: isDisabled,
                    }) }, { children: children })), _jsx(FlexBox, Object.assign({ alignItems: "center", className: classnames(styles.iconContainer, {
                        [styles.isDisabled]: isFavoriteDisabled,
                    }) }, { children: _jsx(Icon, { className: classnames(styles.icon, {
                            [styles.isFavorite]: isFavorite,
                        }), name: isFavorite ? 'star-full' : 'star', onClick: handleFavoriteToggle }) }))] })) })));
};
